module.exports = __webpack_public_path__ + "img/map-location_dark.a9a4c0df.svg";